import {
  ChevronRight as LucideChevronRight,
  ChevronLeft as LucideChevronLeft,
  ArrowRight as LucideArrowRight,
  ArrowLeft as LucideArrowLeft,
} from "lucide-react";

// These four icons carry LTR-only directional meaning (forward = right,
// back = left). Wrapping them here means every call site that imports from
// this module instead of "lucide-react" flips automatically once an
// ancestor has dir="rtl" (see applyDocumentDirection in constants/languages),
// without needing an rtl:rotate-180 className at each of the ~30 usages.
const withRtlFlip = (Icon) => {
  const Wrapped = ({ className = "", ...props }) => (
    <Icon className={`rtl:rotate-180 ${className}`} {...props} />
  );
  Wrapped.displayName = `RtlFlipped(${Icon.displayName || Icon.name || "Icon"})`;
  return Wrapped;
};

export const ChevronRight = withRtlFlip(LucideChevronRight);
export const ChevronLeft = withRtlFlip(LucideChevronLeft);
export const ArrowRight = withRtlFlip(LucideArrowRight);
export const ArrowLeft = withRtlFlip(LucideArrowLeft);
